import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const teamStats = [
  { number: '7500 +', label: 'Projet' },
  { number: '3500 +', label: 'Clients' },
  { number: '540 +', label: 'Experts' },
  { number: '20', label: 'Années' }
];

const partners = [
  { name: 'Marketing Analytics', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg' },
  { name: 'AllSocial', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/facebook/facebook-original.svg' },
  { name: 'Building Business', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg' },
  { name: 'SMX', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/twitter/twitter-original.svg' },
  { name: 'RedBuzz', logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg' }
];

const Team = () => {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Background Elements */}
        <div className="absolute inset-0 -z-10">
          <div className="absolute top-20 right-20 w-96 h-96 bg-neon-orange/5 rounded-full blur-3xl" />
          <div className="absolute bottom-20 left-20 w-96 h-96 bg-gray-100 rounded-full blur-3xl" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 md:mb-16"
        >
          <span className="text-neon-orange font-medium text-sm md:text-base">NOTRE ÉQUIPE PASSIONNÉE</span>
          <h2 className="text-3xl md:text-4xl font-bold mt-4 mb-4 md:mb-6 px-4">
            Nous sommes une équipe diversifiée de professionnels talentueux
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-sm md:text-base px-4">
            Faites connaissance avec notre équipe et découvrez comment nous pouvons vous aider à réaliser vos projets numériques
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-20">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c"
                alt="Notre équipe en action"
                className="w-full h-48 md:h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/50 to-transparent" />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-6 px-4"
          >
            <p className="text-gray-600 leading-relaxed text-sm md:text-base">
              Notre équipe est engagée à offrir un service client exceptionnel, en travaillant en étroite collaboration avec nos clients pour comprendre leurs besoins et atteindre leurs objectifs. Nous croyons en une approche personnalisée, adaptée à chaque projet, afin de garantir des résultats exceptionnels à chaque fois.
            </p>

            <div className="grid grid-cols-2 gap-4 md:gap-8">
              {teamStats.map((stat, index) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="text-center p-4 md:p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="text-xl md:text-3xl font-bold text-neon-orange mb-2">{stat.number}</div>
                  <div className="text-gray-600 text-sm md:text-base">{stat.label}</div>
                </motion.div>
              ))}
            </div>

            <Link
              to="/reserver"
              className="inline-block w-full md:w-auto bg-gradient-to-r from-neon-orange to-red-600 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-semibold text-sm md:text-base shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Réservez un Appel →
            </Link>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mt-12 md:mt-20"
        >
          <div className="text-center mb-8 md:mb-12">
            <h3 className="text-xl md:text-2xl font-semibold mb-4">Ils nous font confiance</h3>
          </div>
          
          <div className="grid grid-cols-2 md:flex md:flex-wrap justify-center items-center gap-4 md:gap-12">
            {partners.map((partner, index) => (
              <motion.div
                key={partner.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ scale: 1.1 }}
                className="w-full md:w-32 h-24 md:h-32 flex items-center justify-center p-4 bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="w-12 h-12 md:w-16 md:h-16 object-contain grayscale hover:grayscale-0 transition-all duration-300"
                />
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Team;